module.exports = __webpack_public_path__ + "img/webm.9b59e63d.svg";